import { Component, OnInit, OnDestroy, ChangeDetectorRef, Inject } from '@angular/core';
import { FormBuilder, FormControl } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { combineLatest, from, Subject } from 'rxjs';
import { filter, map, switchMap, takeUntil, tap } from 'rxjs/operators';
import { BcitiContextService } from 'src/app/global/services/context/context.abstract.service';
import { Organisation } from '../../global.model';
import { Connector } from '../../services/external-systems/external-systems.model';
import { ExternalSystemsService } from '../../services/external-systems/external-systems.abstract.service';
import { languageSelector, organisationSelector } from '../../store/global.selectors';
import { State } from 'src/app/store';
import { Store } from '@ngrx/store';

@Component({
    selector: 'app-external-systems',
    templateUrl: './external-systems.component.html',
    styleUrls: ['./external-systems.component.scss'],
})
export class ExternalSystemsComponent implements OnInit, OnDestroy {
    destroy$ = new Subject();

    loading = false;
    processingSubmit = false;

    orgConfig: any;
    connector: Connector;
    connectors: [Connector];
    organisation: Organisation;
    lookupData: any;

    message: string;

    public externalSystemsForm = this.formBuilder.group({
        connector: new FormControl('', []),
        userId: new FormControl('', []),
    });

    constructor(
        public translate: TranslateService,
        private externalSystemsService: ExternalSystemsService,
        private formBuilder: FormBuilder,
        private store: Store<State>,
        private cdr: ChangeDetectorRef,
    ) {}

    get userId() {
        return this.externalSystemsForm.get('userId').value;
    }

    ngOnInit() {
        this.store
            .select(organisationSelector)
            .pipe(
                tap(() => (this.loading = true)),
                takeUntil(this.destroy$),
                filter((org) => !!org),
                tap((org) => (this.organisation = org)),
                switchMap((org) =>
                    this.externalSystemsService.getConfiguredConnectors(org.tag).pipe(
                        takeUntil(this.destroy$),
                        tap((connectors) => {
                            this.connectors = connectors;
                            this.processingSubmit = false;
                        }),
                    ),
                ),
                tap(() => {
                    this.cdr.detectChanges();
                    this.loading = false;
                }),
            )
            .subscribe();

        this.store
            .select(languageSelector)
            .pipe(
                takeUntil(this.destroy$),
                tap((lang) => this.translate.use(lang)),
            )
            .subscribe();
    }

    public submit() {
        this.processingSubmit = true;
        this.init();
        this.externalSystemsService
            .getExternalSystemLookup(this.connector.tag, this.userId, this.organisation.tag)
            .pipe(takeUntil(this.destroy$))
            .subscribe(
                (response) => {
                    this.lookupData = response;
                    this.processingSubmit = false;
                },
                (error) => {
                    this.processingSubmit = false;
                    this.message = this.translate.instant('pages.external-systems.messages.error');
                },
            );
    }

    public connectorChange(connector: any) {
        this.init();
        this.externalSystemsForm.controls['userId'].setValue('');
        this.connector = connector;
    }

    public init() {
        this.message = '';
        this.lookupData = '';
    }

    ngOnDestroy() {
        this.destroy$.next();
        this.destroy$.complete();
    }
}
